import { useQuery } from "@tanstack/react-query"
import { fetchKioskDevice } from "../api"

/** What the server knows about this tablet's credential, shared by every screen. */
export const kioskDeviceQueryKey = ["kiosk-device"] as const

/**
 * The tablet's own device record: the welcome screen's guard, the kiosk login
 * page and the location settings page all ask the same question, so they share
 * one answer, and a save on the settings page refreshes it for the others.
 *
 * A 401 means no usable credential (ADR-025): the client does not retry it or
 * report it. Each screen names itself as the `source` of any other failure, so
 * telemetry still says which screen hit it.
 *
 * Sharing an answer is not the same as trusting an old one. A screen that acts
 * on whether the tablet is enrolled waits for a fresh answer first — see
 * KioskProtectedRoute and KioskLoginPage, which render nothing while one is in
 * flight.
 */
export function useKioskDevice(source: string) {
  return useQuery({
    queryKey: kioskDeviceQueryKey,
    queryFn: fetchKioskDevice,
    meta: { source },
  })
}
